import Helper from "src/support/Helper";
import Base from "./Base";
import { isArray } from "underscore";

class ProductListing extends Base {
    toObjectWithERPPartNumber(direct_res = false, ERPPartNumbers_asked_params = false) {
        let b = {};
        if (direct_res.value !== undefined &&
            direct_res.value.length
        ) {
            let ItemNumber_r = {};
            let ERPPartNumber_r = {};
            direct_res.value.map((v) => {
                b[v.ERPPartNumber] = v;
                b[v.ItemNumber] = v;
                ERPPartNumber_r[v.ItemNumber] = v;
                ItemNumber_r[v.ItemNumber] = v;
            });
            let left_res_based_on_ERPPartNumbers_asked_params = {};
            if (ERPPartNumbers_asked_params && isArray(ERPPartNumbers_asked_params) && ERPPartNumbers_asked_params.length > 0) {
                ERPPartNumbers_asked_params.map((v_p) => {
                    if (b[v_p.ERPPartNumber] === undefined) {
                        left_res_based_on_ERPPartNumbers_asked_params[v_p.ERPPartNumber] = v_p;
                    }
                })
            }
            if (left_res_based_on_ERPPartNumbers_asked_params && Object.entries(left_res_based_on_ERPPartNumbers_asked_params).length > 0) {
                Object.entries(left_res_based_on_ERPPartNumbers_asked_params).map((v) => {
                    if (ItemNumber_r[v[1].ERPPartNumber] !== undefined) {
                        b[v[0]] = ItemNumber_r[v[1].ERPPartNumber]
                    }
                    if (ERPPartNumber_r[v[1].ERPPartNumber] !== undefined) {
                        b[v[0]] = ERPPartNumber_r[v[1].ERPPartNumber]
                    }
                });
            }
        }
        return b;
    }

    toGroupedObjectWithERPPartNumber(direct_res = false) {
        let b = [];
        if (direct_res !== undefined &&
            direct_res.length
        ) {
            direct_res.map((v, i) => {
                b.push(v);
            })
        }
        return b;
    }

    toObjectWithItemNumber(direct_res = false) {
        let productList = {};
        if (direct_res !== undefined && direct_res.length > 0) {
            direct_res.map((v) => {
                v.Manufacturer = Helper.valueIsNotNull(v.ManufacturerName) ? v.ManufacturerName : "";
                productList[v.ItemNumber] = v;
            });
        } else if (direct_res?.value && direct_res.value.length > 0) {
            direct_res.value.map((v) => {
                productList[v.ItemNumber] = v;
            });
        }
        return productList;
    }
    attachInventoryAndPricingToProductObjectNew(products, assets = {}) {
        let b = {};
        if (products) {
            products = Object.entries(products);
            products.map((v, i) => {
                let h_v = { ...v[1] };
                h_v.assets = {};
                /**
                 * if erppartnumber null set manufacturer part number at assets
                 * Author: Devanshi Patel
                 */
                Object.entries(assets).map((value, index) => {

                    if (value[0] === 'pricing') {
                        if (value[1] && value[1][v[1].ERPMFRPartNumber]) {
                            h_v.assets[value[0]] = value[1][v[1].ERPMFRPartNumber];
                        } else {
                            h_v.assets[value[0]] = [];
                        }
                    } else if (value[0] === 'inventory') {
                        if (value[1] && value[1][v[1].ERPPartNumber] !== undefined) {
                            h_v.assets[value[0]] = value[1][v[1].ERPPartNumber];
                        } else if (value[1] && !value[1][v[1].ERPPartNumber] && value[1][v[1].ManufacturerPartNumber]) {
                            h_v.assets[value[0]] = value[1][v[1].ManufacturerPartNumber];
                        }
                        else {
                            h_v.assets[value[0]] = {
                                qas: 0,
                                quantity: 0
                            };
                        }
                    } else {
                        h_v.assets[value[0]] = {};
                    }

                });
                b[v[0]] = h_v;
            })
        }
        return b;
    }
}

export default ProductListing;